import { Component } from '@angular/core';

@Component({
  selector: 'app-big-loader',
  standalone: true,
  imports: [],
  templateUrl: './big-loader.component.html',
  styleUrl: './big-loader.component.scss'
})
export class BigLoaderComponent {

}
